import React, {useState, useEffect} from "react"
import { 
    Grid, 
    GridColumn, 
    Dropdown,
    Tab, 
    TabPane,
    TableRow,
    TableHeaderCell,
    TableHeader,
    TableFooter,
    TableCell,
    TableBody,
    Table,
    Input,
    Modal,
    Button
 } from "semantic-ui-react"
import axios from "axios";

const TWILIO_WEBHOOK = "https://api.axc.ae/webhook/b1acf1f9-ffab-4131-9379-7bfb7cea29fe";

const normalizeWebhookRows = (payload) => {
    let parsedPayload = payload;

    if (typeof parsedPayload === 'string') {
        try {
            parsedPayload = JSON.parse(parsedPayload);
        } catch (error) {
            return [];
        }
    }

    const candidates = [
        parsedPayload,
        parsedPayload?.body,
        parsedPayload?.data,
        parsedPayload?.rows,
        parsedPayload?.result,
        parsedPayload?.items,
        parsedPayload?.json,
        parsedPayload?.[0]?.json,
        parsedPayload?.[0]?.body,
        parsedPayload?.[0]?.data
    ];

    const rows = candidates.find(candidate => Array.isArray(candidate));

    return Array.isArray(rows)
        ? rows.map(row => row?.json || row?.body || row)
        : (console.warn('Webhook returned no row array:', parsedPayload), []);
}

const IntegrationTable = ({ refreshKey }) => {
    // const [data, setData] = useState([
    //     { id: 1, code: 'ABC123', details: 'Source 1', responsible: 'John Doe' },
    //     { id: 2, code: 'XYZ456', details: 'Source 2', responsible: 'Jane Smith' },
    //     { id: 3, code: 'DEF789', details: 'Source 3', responsible: 'Alice Brown' },
    //     { id: 4, code: 'GHI101', details: 'Source 4', responsible: 'Bob White' },
    // ]);
    const [data, setData] = useState([])
    const [projects, setAd_project] = useState([])
    const [languages, setLanguage] = useState([])
    const [responsible, setResponsible] = useState([])
    const [tags, setTags] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [columnFilters, setColumnFilters] = useState({})
    const [sortConfig, setSortConfig] = useState({ column: 'id', direction: 'descending' })
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [editModalOpen, setEditModalOpen] = useState(false)
    const [editedData, setEditedData] = useState({})
    const [saveMessage, setSaveMessage] = useState('')

    const fetchTags = async () => {
        try {
            let start = 0;
            let allTags = [];

            while (start !== null) {
                const response = await axios.post(`https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/lists.element.get?IBLOCK_TYPE_ID=lists&IBLOCK_ID=189&ELEMENT_ORDER%5BID%5D=ASC&start=${start}`, {})
                allTags = allTags.concat(response.data.result || []);
                start = response.data.next ?? null;
            }

            setTags(allTags);
        } catch (error) {
            console.error('ошибка ', error)
        }
    }
    

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(TWILIO_WEBHOOK, {
                    source: "twilio",
                    action: "list"
                })
                setData(normalizeWebhookRows(response.data));
            } catch (error) {
                console.error('ошибка ', error)
            }
        }
        
        const adProjectData = async () => {
            try {
                const response = await axios.post('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1568907438', {})
                setAd_project(response.data.result[0].LIST);
            } catch (error) {
                console.error('ошибка ', error)
            }
        }

        const adLanguage = async () => {
            try {
                const response = await axios.post('https://crm.axcap.ae/rest/1/a9czkhedx3mmmn04/crm.lead.userfield.list?filter%5BFIELD_NAME%5D=UF_CRM_1553165368131', {})
                setLanguage(response.data.result[0].LIST);
            } catch (error) {
                console.error('ошибка ', error)
            }
        }

        const responsibleData = async () => {
            try {
                const response = await axios.get('https://crm.axcap.ae/local/webhooks/getUserIdName.php?api_key=UPmcMSpk86SLPprv')
                setResponsible(response.data);
            } catch (error) {
                console.error('ошибка ', error)
            }
        }

        adLanguage()
        adProjectData()
        fetchTags()
        responsibleData()
        fetchData()
    }, [refreshKey])

    const fetchData = async () => {
        try {
            const response = await axios.post(TWILIO_WEBHOOK, {
                source: "twilio",
                action: "list"
            })
            setData(normalizeWebhookRows(response.data));
        } catch (error) {
            console.error('ошибка ', error)
        }
    }

    const transformProject = projects.map(project => ({
        key: project.ID,
        text: project.VALUE,
        value: project.ID
    }))

    const transformLanguage = languages.map(language => ({
        key: language.ID,
        text: language.VALUE,
        value: language.ID
    }))

    const transformTags = tags.map(tag => ({
        key: tag.ID,
        text: tag.NAME,
        value: tag.ID
    }))

    const transformResponsible = responsible.map(responsibleItem => ({
        key: responsibleItem.ID,
        text: responsibleItem.NAME,
        value: responsibleItem.ID
    }))
    transformResponsible.push({key: 1, text: 'AX CAPITAL', value: '1'})

    const sortableColumns = [
        { key: 'id', label: 'ID' },
        { key: 'code', label: 'Code' },
        { key: 'source_details', label: 'Source Details' },
        { key: 'project', label: 'Project' },
        { key: 'language', label: 'Language' },
        { key: 'hidden_source', label: 'Hidden Source' },
        { key: 'marker', label: 'Marker' },
        { key: 'tags', label: 'Tags' },
        { key: 'responsible', label: 'Responsible' },
        { key: 'created_at', label: 'Created At' }
    ]

    const pageSizeOptions = [
        { key: 10, text: '10', value: 10 },
        { key: 25, text: '25', value: 25 },
        { key: 50, text: '50', value: 50 },
        { key: 100, text: '100', value: 100 }
    ]

    const getProjectValue = (projectId) => {
        const project = projects.find(p => p.ID === projectId?.toString())
        return project ? project.VALUE : 'Undefined';
    }

    const getLanguageValue = (languageID) => {
        const language = languages.find(p => p.ID === languageID?.toString())
        return language ? language.VALUE : 'Undefined';
    }

    const getTagsValue = (tagIds) => {
        if (!Array.isArray(tagIds) || tagIds.length === 0) {
            return '';
        }

        return tagIds
            .map(tagId => tags.find(tag => tag.ID === tagId?.toString())?.NAME)
            .filter(Boolean)
            .join(', ');
    }

    const getResponsibleValue = (responsibleId) => {
        if (responsibleId?.toString() === '1') {
            return 'AX CAPITAL';
        }

        const responsibleItem = responsible.find(item => item.ID === responsibleId?.toString())
        return responsibleItem ? responsibleItem.NAME : 'INDIVIDUAL';
    }

    const getCreatedAtValue = (createdAt) => {
        if (!createdAt) {
            return '';
        }

        return new Date(createdAt).toLocaleString();
    }

    const getColumnValue = (item, column) => {
        switch (column) {
            case 'id':
                return item.id;
            case 'code':
                return item.code || '';
            case 'source_details':
                return item['source details'] || '';
            case 'project':
                return getProjectValue(item.ad_project);
            case 'language':
                return getLanguageValue(item.ad_language);
            case 'hidden_source':
                return item.hidden_source || '';
            case 'marker':
                return item.marker || '';
            case 'tags':
                return getTagsValue(item.tags);
            case 'responsible':
                return getResponsibleValue(item.responsible);
            case 'created_at':
                return item.created_at || '';
            default:
                return '';
        }
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value)
        setCurrentPage(1)
    }

    const handleColumnFilterChange = (column, value) => {
        setColumnFilters(prevFilters => ({
            ...prevFilters,
            [column]: value
        }))
        setCurrentPage(1)
    }

    const handleSort = (column) => {
        setSortConfig(prevSort => ({
            column,
            direction: prevSort.column === column && prevSort.direction === 'ascending'
                ? 'descending'
                : 'ascending'
        }))
        setCurrentPage(1)
    }

    const openEditModal = (rowData) => {
        setEditedData({
            id: rowData.id,
            code: rowData.code || '',
            source_detail: rowData['source details'] || '',
            Ad_Project: rowData.ad_project?.toString() || '',
            Ad_Language: rowData.ad_language?.toString() || '',
            responsible: rowData.responsible?.toString() || '',
            marker: rowData.marker || '',
            tags: Array.isArray(rowData.tags) ? rowData.tags.map(tag => tag.toString()) : []
        })
        setSaveMessage('')
        setEditModalOpen(true)
    }

    const closeEditModal = () => {
        setEditModalOpen(false)
        setEditedData({})
    }

    const updateEditedData = (fieldName, value) => {
        setEditedData(prevData => ({
            ...prevData,
            [fieldName]: value
        }))
    }

    const handleSave = async () => {
        try {
            const response = await axios.post(TWILIO_WEBHOOK, {
                source: "twilio",
                action: "update",
                fields: editedData,
            });

            setSaveMessage(response.data?.message || 'Saved')
            await fetchData()
            closeEditModal()
        } catch (error) {
            console.error('Ошибка обновления интеграции: ', error)
            setSaveMessage('Save error')
        }
    }


    const filteredData = data.filter(item => {
        const globalSearch = searchTerm.toLowerCase();
        const matchesGlobalSearch = !globalSearch || sortableColumns.some(column =>
            getColumnValue(item, column.key).toString().toLowerCase().includes(globalSearch)
        );

        const matchesColumnFilters = sortableColumns.every(column => {
            const filterValue = columnFilters[column.key]?.toLowerCase();

            if (!filterValue) {
                return true;
            }

            return getColumnValue(item, column.key).toString().toLowerCase().includes(filterValue);
        });

        return matchesGlobalSearch && matchesColumnFilters;
    });

    const sortedData = [...filteredData].sort((firstItem, secondItem) => {
        const firstValue = getColumnValue(firstItem, sortConfig.column);
        const secondValue = getColumnValue(secondItem, sortConfig.column);

        if (typeof firstValue === 'number' && typeof secondValue === 'number') {
            return sortConfig.direction === 'ascending'
                ? firstValue - secondValue
                : secondValue - firstValue;
        }

        return sortConfig.direction === 'ascending'
            ? firstValue.toString().localeCompare(secondValue.toString(), undefined, { numeric: true })
            : secondValue.toString().localeCompare(firstValue.toString(), undefined, { numeric: true });
    });

    const totalPages = Math.max(1, Math.ceil(sortedData.length / itemsPerPage));
    const pageStartIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = sortedData.slice(pageStartIndex, pageStartIndex + itemsPerPage);

    const changePage = (nextPage) => {
        setCurrentPage(Math.min(Math.max(nextPage, 1), totalPages))
    }

    return(
        <div>
            <div className='twilio-table-toolbar'>
                <Input
                    icon='search'
                    placeholder='Search all columns...'
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
                <div className='twilio-pagination-size'>
                    <span>Rows</span>
                    <Dropdown
                        selection
                        options={pageSizeOptions}
                        value={itemsPerPage}
                        onChange={(e, data) => {
                            setItemsPerPage(data.value)
                            setCurrentPage(1)
                        }}
                    />
                </div>
            </div>
            <div className='twilio-table-scroll'>
                <Table celled sortable className='twilio-integrations-table'>
                    <TableHeader>
                        <TableRow>
                            {sortableColumns.map(column => (
                                <TableHeaderCell
                                    key={column.key}
                                    sorted={sortConfig.column === column.key ? sortConfig.direction : null}
                                    onClick={() => handleSort(column.key)}
                                >
                                    {column.label}
                                </TableHeaderCell>
                            ))}
                            <TableHeaderCell>Edit</TableHeaderCell>
                        </TableRow>
                        <TableRow className='twilio-column-filters'>
                            {sortableColumns.map(column => (
                                <TableHeaderCell key={column.key}>
                                    <Input
                                        size='mini'
                                        fluid
                                        placeholder='Filter...'
                                        value={columnFilters[column.key] || ''}
                                        onChange={(e) => handleColumnFilterChange(column.key, e.target.value)}
                                    />
                                </TableHeaderCell>
                            ))}
                            <TableHeaderCell />
                        </TableRow>
                    </TableHeader>

                    <TableBody>
                        {currentItems.map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <TableCell>{item.code}</TableCell>
                                <TableCell>{item['source details']}</TableCell>
                                <TableCell>{getProjectValue(item.ad_project)}</TableCell>
                                <TableCell>{getLanguageValue(item.ad_language)}</TableCell>
                                <TableCell>{item.hidden_source}</TableCell>
                                <TableCell>{item.marker}</TableCell>
                                <TableCell>{getTagsValue(item.tags)}</TableCell>
                                <TableCell>{getResponsibleValue(item.responsible)}</TableCell>
                                <TableCell>{getCreatedAtValue(item.created_at)}</TableCell>
                                <TableCell>
                                    <Button onClick={() => openEditModal(item)}>Edit</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                        {currentItems.length === 0 && (
                            <TableRow>
                                <TableCell colSpan='11' textAlign='center'>
                                    Empty
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>

                    <TableFooter>
                    <TableRow>
                        <TableHeaderCell colSpan='11'>
                            <div className='twilio-pagination'>
                                <span>
                                    Showing {sortedData.length === 0 ? 0 : pageStartIndex + 1}-{Math.min(pageStartIndex + itemsPerPage, sortedData.length)} of {sortedData.length}
                                </span>
                                <div>
                                    <Button onClick={() => changePage(1)} disabled={currentPage === 1}>First</Button>
                                    <Button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>Previous</Button>
                                    <span className='twilio-page-label'>Page {currentPage} of {totalPages}</span>
                                    <Button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>Next</Button>
                                    <Button onClick={() => changePage(totalPages)} disabled={currentPage === totalPages}>Last</Button>
                                </div>
                            </div>
                        </TableHeaderCell>
                    </TableRow>
                    </TableFooter>
                </Table>
            </div>
            {saveMessage && (
                <p className="filter-notes">{saveMessage}</p>
            )}
            <Modal open={editModalOpen} onClose={closeEditModal} className='twilio-edit-modal'>
                <Modal.Header>Edit Twilio Integration</Modal.Header>
                <Modal.Content>
                    <Grid columns='equal'>
                        <Grid.Row>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Campaign Code</span>
                                    <Input
                                        value={editedData.code || ''}
                                        onChange={(e) => updateEditedData('code', e.target.value)}
                                    />
                                </div>
                            </Grid.Column>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Responsible</span>
                                    <Dropdown
                                        placeholder='select responsible'
                                        fluid
                                        search
                                        selection
                                        options={transformResponsible}
                                        value={editedData.responsible}
                                        onChange={(e, data) => updateEditedData('responsible', data.value)}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Project</span>
                                    <Dropdown
                                        placeholder='Select Project'
                                        fluid
                                        search
                                        selection
                                        options={transformProject}
                                        value={editedData.Ad_Project}
                                        onChange={(e, data) => updateEditedData('Ad_Project', data.value)}
                                    />
                                </div>
                            </Grid.Column>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Language</span>
                                    <Dropdown
                                        placeholder='Select Language'
                                        fluid
                                        search
                                        selection
                                        options={transformLanguage}
                                        value={editedData.Ad_Language}
                                        onChange={(e, data) => updateEditedData('Ad_Language', data.value)}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Source Details</span>
                                    <Input
                                        value={editedData.source_detail || ''}
                                        onChange={(e) => updateEditedData('source_detail', e.target.value)}
                                    />
                                </div>
                            </Grid.Column>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Marker</span>
                                    <Input
                                        value={editedData.marker || ''}
                                        onChange={(e) => updateEditedData('marker', e.target.value)}
                                    />
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <div className='item'>
                                    <span>Tags</span>
                                    <Dropdown
                                        placeholder='Select Tags'
                                        fluid
                                        multiple
                                        search
                                        selection
                                        options={transformTags}
                                        value={editedData.tags || []}
                                        onOpen={fetchTags}
                                        onChange={(e, data) => updateEditedData('tags', data.value)}
                                    />
                                </div>
                            </Grid.Column>
                            <Grid.Column>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={closeEditModal}>Cancel</Button>
                    <Button primary onClick={handleSave}>Save</Button>
                </Modal.Actions>
            </Modal>
        </div>
    )
}

const DuplicatesTable = () => {
    const [data, setData] = useState([])
    const [responseReset, setRespondReset] = useState('')

    const fetchData = async () => {
        try {
            const response = await axios.post(TWILIO_WEBHOOK, {
                source: "twilio",
                action: "listDuplicates"
            })
            setData(normalizeWebhookRows(response.data))
        } catch (error) {
            console.log('ошибка', error)
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    const resetFilter = async () => {
        try {
            const response = await axios.post(TWILIO_WEBHOOK, {
                source: "twilio",
                action: "resetDuplicates"
            })
            console.log(response.data)
            setRespondReset(response.data)
            await fetchData()
        } catch (error) {
            console.error('ошибка', error)
        }
    }
    

    return (
        <div>
            <Button onClick={resetFilter} secondary>Reset Filter</Button>
            {responseReset && (
                <p className="filter-notes">Filter reseted</p>
            )}
            <Table celled>
                <TableHeader>
                <TableRow>
                    <TableHeaderCell>Phone</TableHeaderCell>
                    <TableHeaderCell>ProfileName</TableHeaderCell>
                </TableRow>
                </TableHeader>

                <TableBody>
                    {data.length > 0 ? (
                        data.map((item, index) => (
                            <TableRow>
                                <TableCell>{item.phone}</TableCell>
                                <TableCell>{item.ProfileName}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan="2" style={{ textAlign: 'center' }}>
                                Empty
                            </TableCell>
                        </TableRow>
                    )}
                    
                </TableBody>

                <TableFooter>
                <TableRow>
                    <TableHeaderCell colSpan='2'>
                    {/* <Menu floated='right' pagination>
                        <MenuItem as='a' icon>
                        <Icon name='chevron left' />
                        </MenuItem>
                        <MenuItem as='a'>1</MenuItem>
                        <MenuItem as='a'>2</MenuItem>
                        <MenuItem as='a'>3</MenuItem>
                        <MenuItem as='a'>4</MenuItem>
                        <MenuItem as='a' icon>
                        <Icon name='chevron right' />
                        </MenuItem>
                    </Menu> */}
                    </TableHeaderCell>
                </TableRow>
                </TableFooter>
            </Table>
        </div>
    )
}

export default function TwilioData({ refreshKey }){
    const panes = [
        { menuItem: 'Twilio Integrations', render: () => <TabPane><IntegrationTable refreshKey={refreshKey}/></TabPane> },
        { menuItem: 'Twilio Filter', render: () => <TabPane><DuplicatesTable/></TabPane> }
    ]

    return(
        <>
            <div className="twilio-dataTable">
                <Grid columns={1}>
                    <GridColumn>
                        <Tab panes={panes}/>
                    </GridColumn>
                </Grid>
            </div>
        </>
    )
}
